import { storage } from "@/lib/storage";

// 382: skleněné plochy (laboratoř „Proyekty v pohybu“, Tvůj mix). Volba v Nastavení › Vzhled:
// auto (výchozí) / on / off. Bez skla = třída `pp-noglass` na <html> — CSS pak vypne každé rozostření
// a průsvitné plochy udělá plné (starší počítač, vzdálená plocha, úsporný režim).
// Automatika vypne sklo hned na slabém zařízení (2 jádra / 2 GB, systémové „omezit průhlednost“)
// a jinak hlídá posouvání: když je medián snímku dvakrát po sobě nad 28 ms (pod ~35 fps), sklo vypne
// a zapamatuje si to (`pp-glass-auto` = slow). Ruční volba v Nastavení automatiku přebije.
const KEY = "pp-glass";
const AUTO = "pp-glass-auto";
export const GLASS_EVENT = "pp-glass";

export const glassMode = () => { const v = storage.get(KEY); return v === "on" || v === "off" ? v : "auto"; };
export const glassSlow = () => storage.get(AUTO) === "slow";
const lowSpec = () => {
  const n = typeof navigator !== "undefined" ? navigator : {};
  const reduced = typeof window !== "undefined" && window.matchMedia?.("(prefers-reduced-transparency: reduce)")?.matches;
  return (n.hardwareConcurrency > 0 && n.hardwareConcurrency <= 2) || (n.deviceMemory > 0 && n.deviceMemory <= 2) || !!reduced;
};
export const glassOn = (mode = glassMode()) => mode === "on" || (mode === "auto" && !glassSlow() && !lowSpec());

export function applyGlass() {
  if (typeof document === "undefined") return;
  document.documentElement.classList.toggle("pp-noglass", !glassOn());
}

export function setGlassMode(mode) {
  storage.set(KEY, mode);
  if (mode === "auto") storage.remove(AUTO);   // znovu změřit
  applyGlass();
  window.dispatchEvent(new Event(GLASS_EVENT));
}

// Medián délky snímku (ms) z časů requestAnimationFrame; málo snímků = velmi pomalé.
export function medianFrame(ts) {
  if (ts.length < 6) return 1000;
  const d = ts.slice(1).map((t, i) => t - ts[i]).sort((a, b) => a - b);
  return d[Math.floor(d.length / 2)];
}

// Hlídač při posouvání (jen v režimu auto se zapnutým sklem). Vrací funkci, která ho zastaví.
export function watchGlass({ limit = 28, sample: ms = 700 } = {}) {
  if (typeof window === "undefined" || glassMode() !== "auto" || !glassOn()) return () => {};
  let bad = 0, busy = false;
  const stop = () => window.removeEventListener("scroll", onScroll, true);
  function onScroll() {
    if (busy) return;
    busy = true;
    const ts = [];
    const t0 = performance.now();
    const step = (t) => {
      ts.push(t);
      if (t - t0 < ms) { requestAnimationFrame(step); return; }
      busy = false;
      if (medianFrame(ts) > limit) {
        bad += 1;
        if (bad >= 2) {
          storage.set(AUTO, "slow");
          applyGlass();
          window.dispatchEvent(new Event(GLASS_EVENT));
          stop();
        }
      } else bad = 0;
    };
    requestAnimationFrame(step);
  }
  window.addEventListener("scroll", onScroll, { capture: true, passive: true });
  return stop;
}
